import { render, staticRenderFns } from "./verifyEmail.vue?vue&type=template&id=5d97dbe5&scoped=true"
import script from "./verifyEmail.vue?vue&type=script&lang=js"
export * from "./verifyEmail.vue?vue&type=script&lang=js"
import style0 from "./verifyEmail.vue?vue&type=style&index=0&id=5d97dbe5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d97dbe5",
  null
  
)

export default component.exports